module.exports = __webpack_public_path__ + "img/a74470df8af017b28b382b75e9d6ae04.svg";